module.exports = __webpack_public_path__ + "img/logo_ko_w.27e1a6ff.svg";